import Link from 'components/common/link';
import cn from 'classnames';
import useMobile from 'hooks/useMobile';

export const CutOffReminder = ({
  className,
}: {
  className?: string;
}) => {
  const isMobile = useMobile();

  return (
    <span className={cn(className)}>
      Never miss a cutoff again. {isMobile && <br />}
      <Link
        to="https://calendar.google.com/calendar/ical/c_ca4b00cdc8bd1541dfa94a2fefba5334cafa4f7d924272d7557a51fe2fa734fa%40group.calendar.google.com/public/basic.ics"
        target="_blank"
        className="tw-text-white tw-underline tw-font-semibold tw-rounded-lg tw-items-center tw-gap-1"
      >
        <>Add to your calendar now.</>
      </Link>
    </span>
  );
};
